var FormatterType;
(function (FormatterType) {
    FormatterType["number"] = "number";
    FormatterType["currency"] = "currency";
    FormatterType["date"] = "date";
    FormatterType["dateDetailed"] = "date-detailed";
    FormatterType["hour"] = "hour";
    FormatterType["dateTime"] = "date-time";
})(FormatterType || (FormatterType = {}));

export { FormatterType };
